var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.6875C14.4926 4.6875 14.0285 5.11875 14.0625 5.625L14.5312 18.2812C14.5312 18.4056 14.5806 18.5248 14.6685 18.6127C14.7564 18.7006 14.8757 18.75 15 18.75C15.1243 18.75 15.2435 18.7006 15.3315 18.6127C15.4194 18.5248 15.4687 18.4056 15.4687 18.2812L15.9375 5.625C15.9715 5.11875 15.5074 4.6875 15 4.6875Z",
    stroke: "#EB5757",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.3125C15.5178 25.3125 15.9375 24.8928 15.9375 24.375C15.9375 23.8572 15.5178 23.4375 15 23.4375C14.4822 23.4375 14.0625 23.8572 14.0625 24.375C14.0625 24.8928 14.4822 25.3125 15 25.3125Z",
    stroke: "#EB5757",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationRed);
export default __webpack_public_path__ + "static/media/exclamationRed.f5ece7f5e624f4ea844ac6106b325ee1.svg";
export { ForwardRef as ReactComponent };